/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Platforms_Web_TitleInputs */

const en_fc_home_platforms_web_title = /** @type {(inputs: Fc_Home_Platforms_Web_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FilmCraft online`)
};

/**
* | output |
* | --- |
* | "FilmCraft online" |
*
* @param {Fc_Home_Platforms_Web_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_platforms_web_title = /** @type {((inputs?: Fc_Home_Platforms_Web_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Platforms_Web_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_platforms_web_title(inputs)
});
export { fc_home_platforms_web_title as "fc.home.platforms.web.title" }